export enum AuthEnums {
  invalidCredentials = "Invalid username or password!",
  successSignup = "User created successfuly!",
  unorthorized = "Not authorized to access this route!",
  signout = "Successfully signed out!",
}
